import { useGetJobsStatusQuery } from 'api/reports-service/reports-service';
import { JobStatus } from 'api/reports-service/reports-service.types';

export const GUEST_JOURNEY_JOB_NAME = 'GUEST_JOURNEY';

/**
 * Report-level readiness + settings-processing status for Guest Journey: the
 * `GUEST_JOURNEY` row of `incentivio-reports/jobs/status`. Drives the pre-run
 * pending state and the settings-processing banner/notice. `undefined` while
 * loading, on error, or when the BE returns no Guest Journey row.
 */
export const useGuestJourneyStatus = (): JobStatus | undefined => {
  const { status } = useGetJobsStatusQuery(undefined, {
    selectFromResult: ({ data }) => ({
      status: data?.data.find(job => job.jobName === GUEST_JOURNEY_JOB_NAME),
    }),
  });
  return status;
};
